import i18next from 'i18next';
import * as Yup from 'yup';

export const securityQuestionValidationSchema = Yup.object().shape({
  answer: Yup.string().required(
    i18next.t('validationSchema.general.answerRequired'),
  ),
});
